<template>
  <a-card :bordered="false">
    <!-- 查询表单 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="系统选择:">
              <a-select
                v-model="query.sysAppId"
                placeholder="请选择"
                allow-clear
                style="width: 100%"
              >
                <a-select-option v-for="item in systemList" :key="item.id" :value="item.id">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="版本号:">
              <a-input v-model="query.versionNum" placeholder="请输入版本号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="12">
            <a-form-item label="更新时间:">
              <a-range-picker
                v-model="dateRange"
                @change="onDateRangeChange"
                format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="handleAdd">新增更新版本日志</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      rowKey="id"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
      :bordered="true"
    >
      <template slot="isVersion" slot-scope="text">
        <a-tag v-if="text === 1 || text === '1'" color="green">是</a-tag>
        <a-tag v-else color="red">否</a-tag>
      </template>
      <template slot="newFeatures" slot-scope="text">
        <div v-if="text" style="max-height: 200px; overflow-y: auto; white-space: pre-wrap;">{{ text }}</div>
        <span v-else>-</span>
      </template>
      <template slot="documentation" slot-scope="text">
        <div v-if="text" style="word-break: break-all;">
          <a :href="text" target="_blank" style="color: #1890ff">{{ getFileName(text) }}</a>
        </div>
        <span v-else>-</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" style="color: #1890ff; margin-right: 8px">编辑</a>
        <a-popconfirm title="确定要删除这条记录吗?" @confirm="handleDelete(record)" okText="确定" cancelText="取消">
          <a style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="isUpdate ? '编辑更新版本日志' : '新增更新版本日志'"
      :width="800"
      :visible="addOrUpdateVisible"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
    >
      <a-form-model
        ref="addOrUpdateForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="系统选择:" prop="sysAppId">
          <a-select
            v-model="formData.sysAppId"
            placeholder="请选择"
            style="width: 100%"
          >
            <a-select-option v-for="item in systemList" :key="item.id" :value="item.id">
              {{ item.appName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="更新版本号:" prop="versionNum">
          <a-input v-model="formData.versionNum" placeholder="请输入版本号" />
        </a-form-model-item>
        <a-form-model-item label="更新时间:" prop="versionTime">
          <a-date-picker
            v-model="formData.versionTime"
            format="YYYY-MM-DD"
            placeholder="选择日期"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="更新内容:">
            <a-textarea
              v-model="formData.newFeatures"
              placeholder="请输入内容"
              :rows="4"
            />
        </a-form-model-item>
        <a-form-model-item label="更新说明文档:">
          <a-upload
            :file-list="fileList"
            :before-upload="beforeUpload"
            :remove="handleRemove"
            :accept="'.pdf,.doc,.docx'"
          >
            <a-button type="primary">
              <a-icon type="upload" />选择文件
            </a-button>
          </a-upload>
          <div v-if="!fileList.length" style="margin-top: 8px; color: #999">未选择任何文件</div>
          <!-- <div v-else style="margin-top: 8px">
            <a-icon type="file" /> {{ fileList[0].name }}
          </div> -->
        </a-form-model-item>
        <a-form-model-item label="是否当前版本:">
          <a-switch :checked="formData.isVersion === 1" @change="handleVersionSwitchChange">
            <template slot="checkedChildren">是</template>
            <template slot="unCheckedChildren">否</template>
          </a-switch>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import moment from 'moment'

const columns = [
  {
    title: '序号',
    dataIndex: 'sort',
    align: 'center',
    width: 80,
    customRender: (text, record, index) => index + 1,
  },
  {
    title: '系统名称',
    dataIndex: 'appName',
    key: 'appName',
    width: 150,
  },
  {
    title: '版本号',
    dataIndex: 'versionNum',
    key: 'versionNum',
    width: 120,
  },
  {
    title: '当前版本',
    dataIndex: 'isVersion',
    key: 'isVersion',
    width: 100,
    scopedSlots: { customRender: 'isVersion' },
  },
  {
    title: '更新内容',
    dataIndex: 'newFeatures',
    key: 'newFeatures',
    scopedSlots: { customRender: 'newFeatures' },
    width: 300,
  },
  {
    title: '说明文档',
    dataIndex: 'documentation',
    key: 'documentation',
    scopedSlots: { customRender: 'documentation' },
    width: 200,
  },
  {
    title: '更新时间',
    dataIndex: 'versionTime',
    key: 'versionTime',
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'SysUpdateLogList',
  data() {
    return {
      needQuery: false, // 禁用mixin的自动查询，手动控制
      queryUrl: '/manager/sys_update_log/selectUpdateLog',
      deleteUrl: '/manager/sys_update_log/delectUpdateLog',
      addUrl: '/manager/sys_update_log/addUpdateLog',
      updateUrl: '/manager/sys_update_log/upUpdateLog',
      query: {
        sysAppId: undefined,
        versionNum: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10,
      },
      dateRange: [],
      columns,
      systemList: [], // 系统列表
      formData: {
        id: '',
        sysAppId: undefined,
        versionNum: '',
        versionTime: null,
        newFeatures: '',
        documentation: '',
        isVersion: 0,
      },
      fileList: [],
      uploadFile: null,
      confirmLoading: false,
      rules: {
        sysAppId: [{ required: true, message: '请选择系统', trigger: 'change' }],
        versionNum: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        versionTime: [{ required: true, message: '请选择更新时间', trigger: 'change' }],
      },
    }
  },
  created() {
    this.getSystemList()
    // 延迟执行，确保mixin的created先完成
    this.$nextTick(() => {
      this.queryList()
    })
  },
  methods: {
    moment,
    // 获取系统列表
    getSystemList() {
      this.$http
        .get('/manager/users/app')
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.systemList = res.data || []
          }
        })
        .catch(() => {})
    },
    // 日期范围变化
    onDateRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.query.startTime = moment(dates[0]).format('YYYY-MM-DD')
        this.query.endTime = moment(dates[1]).format('YYYY-MM-DD')
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    // 查询列表
    queryList() {
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      if (this.query.sysAppId !== undefined && this.query.sysAppId !== null && this.query.sysAppId !== '') {
        params.sysAppId = this.query.sysAppId
      }
      if (this.query.versionNum) {
        params.versionNum = this.query.versionNum
      }
      if (this.query.startTime) {
        params.startTime = this.query.startTime
      }
      if (this.query.endTime) {
        params.endTime = this.query.endTime
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, { params })
        .then((res) => {
          this.dataListLoading = false
          if (res.code === 0 || res.code === 200) {
            const data = res.data || res || {}
            this.list = data.rows || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = []
            this.pagination.total = 0
            this.$message.error(res.message || '查询失败')
          }
        })
        .catch((error) => {
          this.dataListLoading = false
          let resData = null
          if (error.data) {
            resData = error.data
          } else if (error.response && error.response.data) {
            resData = error.response.data
          }
          if (resData && resData.code === 200) {
            const data = resData || {}
            this.list = data.rows || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            return
          }
          const errorMsg = resData?.message || error.message || '查询失败'
          if (errorMsg !== '查询失败') {
            this.$message.error(errorMsg)
          }
        })
    },
    // 重置
    resetList() {
      this.query = {
        sysAppId: undefined,
        versionNum: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10,
      }
      this.dateRange = []
      this.pagination.current = 1
      this.queryList()
    },
    // 分页变化
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
    },
    // 新增
    handleAdd() {
      this.isUpdate = false
      this.addOrUpdateVisible = true
      this.formData = {
        id: '',
        sysAppId: undefined,
        versionNum: '',
        versionTime: null,
        newFeatures: '',
        documentation: '',
        isVersion: 0,
      }
      this.fileList = []
      this.uploadFile = null
      this.$nextTick(() => {
        if (this.$refs.addOrUpdateForm) {
          this.$refs.addOrUpdateForm.clearValidate()
        }
      })
    },
    // 编辑
    handleEdit(record) {
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateVisible = true
      this.formData = {
        id: record.id || '',
        sysAppId: record.sysAppId || undefined,
        versionNum: record.versionNum || '',
        versionTime: record.versionTime ? moment(record.versionTime) : null,
        newFeatures: record.newFeatures || '',
        documentation: record.documentation || '',
        isVersion: record.isVersion !== undefined ? record.isVersion : 0,
      }
      this.fileList = []
      this.uploadFile = null
      if (record.documentation) {
        this.fileList = [
          {
            uid: '-1',
            name: this.getFileName(record.documentation),
            status: 'done',
            url: record.documentation,
          },
        ]
      }
      this.$nextTick(() => {
        if (this.$refs.addOrUpdateForm) {
          this.$refs.addOrUpdateForm.clearValidate()
        }
      })
    },
    // 删除
    handleDelete(record) {
      this.$http
        .post(this.deleteUrl, { ids: [record.id] })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success('删除成功')
            this.queryList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    // 提交
    handleSubmit() {
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          // 先上传文件（如果有新文件）
          if (this.uploadFile) {
            this.uploadDocumentation()
          } else {
            this.submitForm()
          }
        }
      })
    },
    // 上传文档
    uploadDocumentation() {
      const formData = new FormData()
      formData.append('file', this.uploadFile)
      this.confirmLoading = true
      this.$http
        .post('/manager/file/resources/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          if (res.code === 0 && res.data && res.data.url) {
            this.formData.documentation = res.data.url
            this.submitForm()
          } else {
            this.confirmLoading = false
            this.$message.error(res.message || '文件上传失败')
          }
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    // 提交表单
    submitForm() {
      const submitData = {
        sysAppId: this.formData.sysAppId,
        versionNum: this.formData.versionNum,
        versionTime: this.formData.versionTime ? moment(this.formData.versionTime).format('YYYY-MM-DD') : '',
        newFeatures: this.formData.newFeatures || '',
        documentation: this.formData.documentation || '',
        isVersion: this.formData.isVersion || 0,
      }
      // 只有更新时才传id
      if (this.isUpdate) {
        submitData.id = this.formData.id
      }
      this.confirmLoading = true
      const url = this.isUpdate ? this.updateUrl : this.addUrl
      this.$http
        .post(url, submitData)
        .then((res) => {
          this.confirmLoading = false
          if (res.code === 0 || res.code === 200) {
            this.$message.success(this.isUpdate ? '更新成功' : '新增成功')
            this.addOrUpdateVisible = false
            this.queryList()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        })
        .catch(() => {
          this.confirmLoading = false
        })
    },
    // 取消
    handleCancel() {
      this.addOrUpdateVisible = false
      this.formData = {
        id: '',
        sysAppId: undefined,
        versionNum: '',
        versionTime: null,
        newFeatures: '',
        documentation: '',
        isVersion: 0,
      }
      this.fileList = []
      this.uploadFile = null
    },
    // 文件上传前
    beforeUpload(file) {
      this.uploadFile = file
      this.fileList = [
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
        },
      ]
      return false // 阻止自动上传
    },
    // 移除文件
    handleRemove() {
      this.fileList = []
      this.uploadFile = null
      this.formData.documentation = ''
    },
    // 获取文件名
    getFileName(url) {
      if (!url) return ''
      const parts = url.split('/')
      return parts[parts.length - 1]
    },
    // 处理版本开关变化
    handleVersionSwitchChange(checked) {
      this.formData.isVersion = checked ? 1 : 0
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>

